import {AgGridModule} from 'ag-grid-angular';
import {LfsaBotonsGridComponent} from '../../shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import {
  LfsaBotonEditarGridComponent
} from '../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../shared/shared.module';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {ConsultarProcesosComponent} from './views/consultar-procesos/consultar-procesos.component';
import {RPlusRoutingModule} from './rplus-routing.module';
import {EjecutarProcesosComponent} from './views/ejecutar-procesos/ejecutar-procesos.component';
import { ConfigurarCpdComponent } from './views/configurar-cpd/configurar-cpd.component';

@NgModule({
  declarations: [
    ConsultarProcesosComponent,
    EjecutarProcesosComponent,
    ConfigurarCpdComponent, //T.14473 CPD Forzado
  ],
  imports: [
    CommonModule,
    SharedModule,
    RPlusRoutingModule,
    ReactiveFormsModule,
    AgGridModule.withComponents([LfsaBotonEditarGridComponent, LfsaBotonsGridComponent]),
    NgMultiSelectDropDownModule.forRoot()
  ],
})
export class RPlusModule {
}
